import React from 'react'

import { AppRouter } from './routes/AppRouter'





export const EasyBank = () => {
    return (
        <AppRouter />


    )
}
